import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context";
import { getAppInfo } from "../services/console/appinfo";

type UseType = "DATA" | "ACTIONS";
export type ActionType = "CREATE" | "UPDATE" | "DELETE" | "REACTIVE";

const handleAppInfoFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: (data:any) => {},
        fnMsg: "",
      };
    case "UPDATE":
      return {
        actionFn: (data:any) => {},
        fnMsg: "",
      };
    case "DELETE":
      return {
        actionFn: (data:any) => {},
        fnMsg: "",
      };
    case "REACTIVE":
        return {
          actionFn: (data:any) => {},
          fnMsg: "",
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useAppInfo = (type: UseType) => {
  const { t, toast, setAppState, appState: { selectedApp } } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);
  const tenantid = selectedApp?.tenantid || "0";
  const appid = selectedApp?.appid || "0";

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const useroleAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleAppInfoFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg.replace('{name}', data?.name)}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: (
            !!error?.response?.data?.header?.errorMsg &&
            error?.response?.data?.header?.errorMsg !== "Error: 500"
            )
            ? error?.response?.data?.header?.errorMsg
            : t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getAppInfo(tenantid, appid))
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            setData([]);
          });
      })();
    }
  }, [toast, reload, type]);

  return {
    data,
    useroleAction,
    reloadFn,
  };
};
